<!-- <app-dynamic-form [inputRowsObservable]="dynamicInputRows"></app-dynamic-form> -->


<div class="marginAuto">
  <form  #f="ngForm">
  
    <div class="col-lg-3 float-left" *ngIf="!user">
        <div class="sidebar-listing">
           
            <div class="top_heading" >
                <div class="col-md-10">Placeholders <br />
                    <small class="text-secondary mt-2 font12px">Click to Copy Paste the requires Place
                        holders</small>
                </div>
                
            </div>
            <div class="clipbaord-content w-100">
               
                <div *ngFor="let item of placeHolderList;let i=index">
  
                  <div class="row mt-1">
                    <div class="col-9 mx-0 px-0 float-left">
                      <label clas="d-block text-secondary">{{item.description}}</label>
                    </div>
                    <div class="col mx-0 px-0 float-right">
                      <button class="ml-1 copyButton" type="button" pButton ngxClipboard (cbOnSuccess)="copied($event,item,i)"
                        [ngClass]="copiedIndex == i ? 'p-button-success' : 'p-button-outlined'" 
                        [cbContent]="item.name" label="{{copiedIndex == i ? 'Copied' : 'COPY'}}"></button>
                      <span class="pl-1" *ngIf="copiedIndex == i"><small class="text-secondary">Paste
                          Now!</small></span>
                    </div>
                  </div>
                  <!-- <label style="cursor: pointer;" (click)="handleCopy(item)"> {{item.placeHolderDescription}}</label> -->
                </div>
              </div>

            

        
        </div>
    </div>


    <div [ngClass]="{'col-lg-12': user == true,'col-lg-9 float-right': user == false}">
        <div class="rightside-panel">
            <div class="top_heading">
               <div class="col-1 text-left icn" (click)="handleGoback()"><span>&#10094;</span>Back</div>
               <div class="col-8">Create {{letterType === 'COVLTR' ? 'Cover' : 'Support'}} letter template</div>
               <div class="col-2 text-right"><span>&#10094;</span>Preview</div>
                
            </div>
            <div>
              <div class="row title  template-editor-maxwidth headerEditor mt-2">
                <div class="editorBoxContainer">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <h5>Header Section</h5>
                    </div>
                 
                  </div>
                </div>
                <div class="col-md-12">
                <!-- <textarea spellcheck="true" class="pl-3" [(ngModel)]="header"  #templateHeader="ngModel"  name="templateHeader" [froalaEditor]="options"></textarea> -->
                <kendo-editor [(value)]="header" (valueChange)="vddefaulttemplateHeadereditorValueChange($event)" #vddefaulttemplateHeaderkendoeditor style="max-height: 600px; overflow: auto; height: 400px;" name="templateHeader">
                  <kendo-toolbar>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                    <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>                                
                    <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                    <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                      <kendo-toolbar-button
                      title="Upload’s Image at cursor point"
                      text="Upload Image"
                      (click)="openvddefaulttemplateHeaderimageuploaddialog()"
                      ></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>                                  
                  </kendo-toolbar>
              </kendo-editor>
              <app-upload-image-dialog #vddefaulttemplateHeaderupload [editor]="vddefaulttemplateHeaderkendoeditor"></app-upload-image-dialog>
              </div>
              </div>
              </div>
              <div class="row title template-editor-maxwidth headerEditor mt-2">
                <div class="editorBoxContainer">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <h5>Content Section</h5>
                    </div>
                  
                  </div>
                </div>
                <div class="col-md-12">
                <!-- <textarea spellcheck="true" [(ngModel)]="body" name="templateContent" #templateContent="ngModel" [froalaEditor]="options"></textarea> -->
                <kendo-editor [(value)]="body" (valueChange)="vddefaulttemplateContenteditorValueChange($event)" #vddefaulttemplateContentkendoeditor style="max-height: 600px; overflow: auto; height: 400px;" name="templateContent">
                  <kendo-toolbar>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                    <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>                                
                    <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                    <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                      <kendo-toolbar-button
                      title="Upload’s Image at cursor point"
                      text="Upload Image"
                      (click)="openvddefaulttemplateContentimageuploaddialog()"
                      ></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>                                  
                  </kendo-toolbar>
              </kendo-editor>
              <app-upload-image-dialog #vddefaulttemplateContentupload [editor]="vddefaulttemplateContentkendoeditor"></app-upload-image-dialog>
                </div>
              </div>
              </div>
              <div class="row title template-editor-maxwidth footerEditor mt-2">
                <div class="editorBoxContainer">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <h5>Footer Section</h5>
                    </div>
                 
                  </div>
                </div>
                <div class="col-md-12">
                <!-- <textarea spellcheck="true" [(ngModel)]="footer" name="templateFooter" #templateFooter="ngModel" [froalaEditor]="options"></textarea> -->
                <kendo-editor [(value)]="footer" (valueChange)="vddefaulttemplateFootereditorValueChange($event)" #vddefaulttemplateFooterkendoeditor style="max-height: 600px; overflow: auto; height: 400px;" name="templateFooter">
                  <kendo-toolbar>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                    <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                    <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>                                
                    <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                    <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                      <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
                    <kendo-toolbar-buttongroup>
                      <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                      <kendo-toolbar-button
                      title="Upload’s Image at cursor point"
                      text="Upload Image"
                      (click)="openvddefaulttemplateFooterimageuploaddialog()"
                      ></kendo-toolbar-button>
                    </kendo-toolbar-buttongroup>                                  
                  </kendo-toolbar>
              </kendo-editor>
              <app-upload-image-dialog #vddefaulttemplateFooterupload [editor]="vddefaulttemplateFooterkendoeditor"></app-upload-image-dialog>
              </div>
              </div>
              </div>
            </div>
            </div>
    </div>
    <div class="mt-4">
      <p-divider type="dashed" ></p-divider>
    </div>
    <div class="buttonContainer my-2">
      <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="handleGoback()">GO BACK</button></div>
      <div> <button type="submit" class="btn vdCreateBtn mr-3" (click)="handleSave()" *ngIf="isEditVisa">SAVE</button></div>
    </div>
  </form>
  </div>
  
    

    

<div class="clearfix"></div>
